var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-avatar",class:{
    'ab-avatar--rounded': _vm.rounded,
    [`ab-avatar--${_vm.size}`]: true,
    [`ab-avatar--${_vm.color}`]: _vm.color && !_vm.image,
    'ab-avatar--transparent': _vm.image || _vm.color === 'transparent',
  }},[(_vm.icon)?_c('i',{staticClass:"ab-avatar__icon",class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{staticClass:"ab-avatar__image",attrs:{"src":_vm.image}}):_vm._e(),_vm._v(" "),(_vm.initials && !_vm.image)?_c('span',{staticClass:"ab-avatar__initials"},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }